export const SEO_BRAND = "Guatemalan Spirit";
const MAX = 60;

export function seoTitle(main, sub = "") {
  main = (main || "").trim();
  const candidates = sub ? [`${main} — ${sub} | ${SEO_BRAND}`, `${main} | ${SEO_BRAND}`, `${main} — ${sub}`] : [`${main} | ${SEO_BRAND}`];
  const ok = candidates.find((c) => c.length <= MAX);
  if (ok) return ok;
  if (main.length <= MAX) return main;
  const cut = main.slice(0, MAX - 1).split(" ").slice(0, -1).join(" ");
  return cut.replace(/[\s,:;—-]+$/, "") + "…";
}

const DESC_MAX = 155;
const DESC_TAIL = " Guatemalan Spirit, liquorificio artigianale di Salerno. Spedizione in tutta Italia.";

export function seoDescription(text, name = "") {
  let t = (text || "").split(/\s+/).join(" ").trim();
  if (t.length < 70) t = t ? (t + DESC_TAIL).trim() : `${name}: ${DESC_TAIL.trim()}`;
  if (t.length <= DESC_MAX) return t;
  const cut = t.slice(0, DESC_MAX - 1).split(" ").slice(0, -1).join(" ");
  return cut.replace(/[\s,:;—-]+$/, "") + "…";
}
